import React from 'react';
import { Users, Clock } from 'lucide-react'; // Removemos o BrainCircuit

function GameCardV2({ game, onGameClick }) {
    const { id_jogo, nm_jogo, thumb, qt_jogadores_min, qt_jogadores_max, vl_tempo_jogo } = game;

    let playerInfo = qt_jogadores_min === qt_jogadores_max 
        ? qt_jogadores_min 
        : `${qt_jogadores_min}-${qt_jogadores_max}`;

    return (
        <div 
            onClick={() => onGameClick(id_jogo)}
            className="group cursor-pointer relative w-full bg-white rounded-xl p-1.5 md:p-2.5 transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_20px_40px_-15px_rgba(151,18,83,0.3)] border border-[#dbcdac]/40 hover:border-[#971253]/50 flex flex-col h-full shadow-sm"
        >
            {/* Inner Decorative Border */}
            {/* Removemos o padding bottom (pb-0) para o rodapé colar no fundo da borda */}
            <div className="border-[1px] border-[#528a89]/20 rounded-lg pt-2 md:pt-4 px-2 md:px-4 pb-0 flex flex-col h-full relative overflow-hidden group-hover:border-[#971253]/30 transition-colors">
                
                {/* Vintage Corner Ornaments */}
                <div className="absolute top-1 left-1 w-2 h-2 border-t border-l border-[#dbcdac]"></div>
                <div className="absolute top-1 right-1 w-2 h-2 border-t border-r border-[#dbcdac]"></div>
                
                {/* Image Box */}
                <div className="h-32 sm:h-40 md:h-48 w-full flex items-center justify-center mb-3 md:mb-6 relative mt-1 md:mt-0">
                    <img 
                        src={thumb || '/images/placeholder.webp'} 
                        alt={nm_jogo} 
                        className="max-h-full max-w-full object-contain drop-shadow-md mix-blend-multiply group-hover:scale-110 transition-transform duration-700" 
                    />
                </div>

                {/* Title */}
                <div className="flex-grow flex items-center justify-center text-center mb-4 md:mb-6">
                    <h3 className="font-serif text-sm md:text-lg text-[#971253] font-bold leading-snug line-clamp-3 md:line-clamp-2 px-1">
                        {nm_jogo}
                    </h3>
                </div>

                {/* Playing Card Split Bottom Section */}
                {/* Margens negativas nas laterais (-mx-2/-mx-4) para esticar de ponta a ponta */}
                <div className="grid grid-cols-2 border-t border-[#528a89]/20 group-hover:border-[#971253]/30 transition-colors mt-auto -mx-2 md:-mx-4 bg-[#FFF5EE]/30">
                    
                    {/* Left Half: Players */}
                    <div className="flex items-center justify-center gap-2 py-2.5 md:py-3 border-r border-[#528a89]/20 group-hover:border-[#971253]/30 transition-colors text-[#528a89]">
                        <Users size={14} className="shrink-0" /> 
                        <span className="font-serif text-xs md:text-sm font-bold tracking-wide mt-0.5">{playerInfo}</span>
                    </div>
                    
                    {/* Right Half: Time */}
                    <div className="flex items-center justify-center gap-2 py-2.5 md:py-3 text-[#971253]">
                        <Clock size={14} className="shrink-0" /> 
                        <span className="font-serif text-xs md:text-sm font-bold tracking-wide mt-0.5">{vl_tempo_jogo || '-'}m</span>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default GameCardV2;